interface TrustSignalItem {
  icon?: string;
  label: string;
  sublabel?: string;
}

interface TrustSignalsBandProps {
  items: TrustSignalItem[];
  heading?: string;
}

/**
 * TrustSignalsBand
 *
 * Horizontal band with trust badges (certifications, years in business,
 * speaker history, ...). Mirrors the `trustSignals.items` array in service
 * JSONs. Icons are rendered as a small accent dot when no SVG icon is
 * supplied — keep this dependency-free so it works on every page.
 */
export default function TrustSignalsBand({
  items,
  heading,
}: TrustSignalsBandProps) {
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error("TrustSignalsBand: `items` array is empty or invalid.");
  }

  return (
    <div className="trust-band">
      {heading ? <h4 className="trust-band-heading">{heading}</h4> : null}
      <ul className="trust-band-grid">
        {items.map((item) => (
          <li className="trust-band-item" key={item.label}>
            <span className="trust-band-dot" aria-hidden />
            <div>
              <div className="trust-band-label">{item.label}</div>
              {item.sublabel ? (
                <div className="trust-band-sub">{item.sublabel}</div>
              ) : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
